import { hasAnalyticsCookiesConsent } from '../tracking/onetrust';
import {
  getDataAndTrackerForAction,
  getDataAndTrackerForTrackEvent,
  getDefaultData,
  ActionTrackData,
} from '../tracking/prepareTrackData';
import { ANALYTICS } from '../actions/analyticsManager.actions';
import Tracker from '../tracking/tracker';

const prepareAndSendTrackingData = (action: any, reduxState: any) => {
  if (action.type === ANALYTICS) {
    // All ANALYTICS actions are tracked.
    const defaultData = getDefaultData(reduxState);
    const [eventData, tracker] = getDataAndTrackerForTrackEvent(
      action.payload,
      reduxState
    );
    const trackData = { ...defaultData, ...eventData };
    Tracker.send(action.payload.event, trackData, tracker);
  } else {
    const result = getDataAndTrackerForAction(action, reduxState);
    if (result === null) {
      // Do not track the action if result is null
      return;
    }

    const defaultData = getDefaultData(reduxState);

    // Result can be an array of array if we are sending multiple event for single action.
    if (Array.isArray(result[0])) {
      result.forEach(r => {
        const [event, actionTrackData, tracker] = r;
        const trackData = { ...defaultData, ...actionTrackData };
        Tracker.send(event, trackData, tracker);
      });
    } else {
      const [event, actionTrackData, tracker] = result as ActionTrackData;
      const trackData = { ...defaultData, ...actionTrackData };
      Tracker.send(event, trackData, tracker);
    }
  }
};

const middleware = ({ getState }: any) => {
  return (next: any) => (action: any) => {
    if (hasAnalyticsCookiesConsent()) {
      prepareAndSendTrackingData(action, getState());
    }

    // Call the next dispatch method in the middleware chain.
    const returnValue = next(action);
    return returnValue;
  };
};

export default middleware;
try {
    // @ts-ignore
    analyticsManagermiddleware.displayName = "analyticsManagermiddleware";
    // @ts-ignore
    analyticsManagermiddleware.__docgenInfo = { "description": "", "displayName": "analyticsManagermiddleware", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/analyticsManager/middlewares/analyticsManager.middleware.ts#analyticsManagermiddleware"] = { docgenInfo: analyticsManagermiddleware.__docgenInfo, name: "analyticsManagermiddleware", path: "src/analyticsManager/middlewares/analyticsManager.middleware.ts#analyticsManagermiddleware" };
}
catch (__react_docgen_typescript_loader_error) { }